import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import React, { useRef, useEffect } from "react";
import { Button } from "@sw-sw/lib-ui";
import Logo from "../../../images/SW-Logo-White.svg";
import { Link } from "react-router-dom";
import Breadcrumbs from "../BreadCrumbs/BreadCrumbs";
import tenantSetupApi from "../../../utils/api/tenantSetup";
import striepApi from "../../../utils/api/stripeAPI";

const TrialStartedPage: React.FC = () => {
  const printRef = useRef<any>();
  let freeTrialUserData: any = localStorage.getItem('freeTrialUserData')
  let freeTrialUserParsedData = JSON.parse(freeTrialUserData)

  let addOnsFormattedStringValue = () => {
    if (freeTrialUserParsedData && freeTrialUserParsedData.selectedAddOns && Array.isArray(freeTrialUserParsedData.selectedAddOns) && freeTrialUserParsedData.selectedAddOns.length) {
      return freeTrialUserParsedData.selectedAddOns.map((ele: any) => ele.name).join(', ');
    }
    else {
      return '-'
    }
  }

  useEffect(() => {
    tenantSetupApi.create({
      tenantDetails: {
        name: freeTrialUserParsedData.companyName,
        domain: freeTrialUserParsedData.domain,
        payment_method: "billed"
      },
      subscriptionId: freeTrialUserParsedData.subscriptionId,
      userEmail: freeTrialUserParsedData.email,
      selectedAddOns: freeTrialUserParsedData.selectedAddOns
    }).then(async (res) => {
      await striepApi.createCardDetailsEntry(freeTrialUserParsedData.customerId, res.data.tenantId).then(() => {
        console.log("Card details entry created successfully");
      })
    }).catch((err) => {
      console.log("Error in creating tenant: ", err);
    })
  }, []);

  const breadCrumbSteps = [
    "Company and Contact Information",
    "Subdomain and Subscription",
    "Billing and Payment",
  ]

  const contactInfo = {
    "Company": freeTrialUserParsedData ? freeTrialUserParsedData.companyName : '',
    "Email Id": freeTrialUserParsedData ? freeTrialUserParsedData.email : '',
    "Name": freeTrialUserParsedData ? freeTrialUserParsedData.name : '',
    "Phone": freeTrialUserParsedData ? freeTrialUserParsedData.phone : '',
    "Address": freeTrialUserParsedData ? `${freeTrialUserParsedData.city}, ${freeTrialUserParsedData.state}` : ''
  }

  const subdomain = {
    "Custom URL": freeTrialUserParsedData ? `${freeTrialUserParsedData.domain}.sw2.net` : '',
  }

  const subscriptionInformation = {
    "Plan": freeTrialUserParsedData ? freeTrialUserParsedData.subscriptionType : '',
    "AddOns": addOnsFormattedStringValue()
  }

  const paymentInformation = (last4: any, cardType: any) => {
    return {
      "Credit Card No": `XXXX XXXX XXXX ${last4}`,
      "Card Type": cardType,
    }
  }

  const arr = [
    {
      headingLeft: "Company/contact Info",
      headingRight: "",
      body: contactInfo,
    },
    {
      headingLeft: "Subdomain",
      headingRight: "",
      body: subdomain,
    },
    {
      headingLeft: "Subscription Information",
      headingRight: "",
      body: subscriptionInformation,
    },
    {
      headingLeft: "Payment Information",
      headingRight: "",
      body: paymentInformation(4242, "visa"),
    },
    {
      headingLeft: "Total Due Today",
      headingRight: "$00.00",
      body: [],
    },
  ]

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;

    const printStyles = `
      <style>
        @media print {
          * {
            background: none !important;
            box-shadow: none !important;
            color-adjust: exact;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }
        }
      </style>
    `;

    document.body.innerHTML = printStyles + printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload(); // reload to restore event listeners. 
  };

  return (
    <div className="trial-started__wrapper">
      <div className="trial-started">
        <header>
          <div className="trial-started__logo-wrapper">
            <img src={Logo} alt='logo' />
          </div>
          <h3>Already a member? <a href={`${process.env.REACT_APP_LOGIN_URL}/login`}>Login</a></h3>
        </header>
        <div className="trial-started__body">
          <div className="trial-started__inner-box-wrapper">
            <Breadcrumbs steps={breadCrumbSteps} showLastStepCheckSymbol={true} />
            <div className="trial-started__inner-box">
              <div className="trial-started__check-icon">
                <FontAwesomeIcon
                  icon={faCheckCircle}
                  color="#48af98" size="lg"
                  style={{ width: "100px", height: "100px" }}
                />
              </div>
              <h1>Trial Started!</h1>
              <h3>Thank you for trusting SW2 for you digital compliance needs! Your account is being created, please allow for up to 10 minutes for this to be completed and keep an eye out for an email from <strong>info@sw2.net</strong> that contains an invite to your new account.</h3>
              <div className="trial-started__summary-table-wrapper">
                <div className="trial-started__summary" ref={printRef}>
                  <div className="trial-started__summary-heading">
                    <h3>Summary</h3>
                  </div>
                  <div className="trial-started__summary-table">
                    {
                      arr.map((ele, index) => (
                        <>
                          <div className="trial-started__summary-table-section">
                            <div key={index} className="trial-started__table-head">
                              <h3>{ele.headingLeft}</h3>
                              <h3>{ele.headingRight}</h3>
                            </div>

                            {Object.entries(ele.body).map(([key, value], subIndex) => (
                              <div key={`${index}-${subIndex}`} className="trial-started__table-body">
                                <div className="projects-list__table-cell">
                                  {key}
                                </div>

                                {Array.isArray(value) ?
                                  <ol type="a">
                                    {value.map((ele1: any) =>
                                      <li className="projects-list__table-cell">{ele1}</li>
                                    )}
                                  </ol>
                                  :
                                  <div className="projects-list__table-cell">
                                    {value}
                                  </div>
                                }
                              </div>
                            ))}
                          </div>
                          <hr />
                        </>
                      ))
                    }
                  </div>
                </div>
              </div>
              <div className="trial-started__action-buttons">
                <Button primary onClick={handlePrint}>
                  Print
                </Button>
                <Link to='/free-trial'>
                  <Button primary>
                    Close
                  </Button>
                </Link>
              </div>

              <h3>Haven't received your invite? Please contact us at <strong>info@sw2.net</strong> for assistance</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrialStartedPage;
